import { render, staticRenderFns } from "./ChartReport.vue?vue&type=template&id=71a449f1&scoped=true&"
import script from "./ChartReport.vue?vue&type=script&lang=js&"
export * from "./ChartReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a449f1",
  null
  
)

export default component.exports